module.exports = __webpack_public_path__ + "img/1.ccad4992.png";